import { createI18n } from 'vue-i18n'
//引入各个语言的配置
import cn from "./config/cn"; //简体中文
import en from "./config/en"; //英语
import ja from "./config/ja"; //日语
import tw from "./config/tw"; //繁体
import ko from "./config/ko"; //韩语
let language = navigator.language;
if (language) {
  if (language.indexOf("zh") === 0) {
    language = "cn";
  } else if (language.indexOf("en") === 0) {
    language = "en";
  } else if (language.indexOf("ja") === 0) {
    language = "ja";
  } else if (language.indexOf("ko") === 0) {
    language = "ko";
  } else {
    language = "ja";
  }
}
let locale = localStorage.getItem("locale");
if (locale) {
  if (locale === "jp") {
    locale = "ja";
  } else if (locale === "zh") {
    locale = "cn";
  } else if (locale === "tc") {
    locale = "tw";
  } else if (locale === "ko") {
    locale = "ko";
  }
  localStorage.setItem("locale", locale);
}
document.documentElement.setAttribute('lang',localStorage.getItem("locale"));
const i18n = createI18n({
  legacy: false,
  locale: locale || language,
  globalInjection: true,
  fallbackLocale: locale || language,  //备用语言环境
  messages: { cn: cn, ja: ja, en: en, tw: tw, ko: ko }
});
//暴露i18n
export default i18n;
